import { AUTHENTICATION_SUCCESSFUL } from 'src/common/actions/auth';

export default function isAuthFulfilledActionType(type) {
  return type === AUTHENTICATION_SUCCESSFUL;
}
